import React, { useState } from "react"
const CartContext = React.createContext([[], () => { }])
let initialState = JSON.parse(localStorage.getItem('cart'));
const CartProvider = props => {
    const [state, setState] = useState(initialState || [])
    return (
        <CartContext.Provider value={[state, setState]}>
            {props.children}
        </CartContext.Provider>
    )
}
export { CartContext, CartProvider }


// WEBPACK FOOTER //
// ./src/contexts/MovieContext.js